<template>
  <div class="page-content">
    <div class="content-wrap">
      <div class="heading">
        <div class="icon">
          <img
            v-if="hasIcon"
            :src="form.image.icon"
            @error="() => imgError(clientImage.type.icon)"
          />
          <i v-else class="el-icon-warning invalid"> </i>
          <div class="backdrop" @click="() => uploader(clientImage.type.icon)">
            <i class="el-icon-upload"></i>
          </div>
          <el-button
            circle
            type="sc-asset"
            icon="
              el-icon-edit
            "
            class="upload-icon"
            @click="() => uploader(clientImage.type.icon)"
          >
          </el-button>
        </div>
        <div class="cover">
          <img
            v-if="hasCover"
            :src="form.image.cover"
            @error="() => imgError(clientImage.type.cover)"
          />
          <i v-else class="el-icon-warning invalid"> </i>
          <div class="backdrop" @click="() => uploader(clientImage.type.cover)">
            <i class="el-icon-upload"></i>
          </div>
        </div>
        <el-button
          circle
          type="sc-asset"
          icon="
            el-icon-edit
          "
          class="upload-cover"
          @click="() => uploader(clientImage.type.cover)"
        >
        </el-button>
      </div>

      <section class="form grid-2">
        <div class="input">
          <label> ประเภท </label>
          <el-radio-group v-model="form.type">
            <el-radio-button
              v-for="(item, i) in category"
              :key="i"
              :label="item.value"
            >
              {{ item.name }}
            </el-radio-button>
          </el-radio-group>
        </div>
        <div class="input">
          <label>
            <i v-if="valid.code" class="el-icon-circle-check valid" />
            <i v-else class="el-icon-warning invalid" /> รหัส
          </label>
          <input
            v-model="form.code"
            :disabled="mode == 'update'"
            :placeholder="'ระบุรหัสโครงการ'"
            type="text"
            name="code"
            class="input el-input__inner"
          />
        </div>
      </section>

      <section class="form">
        <div class="input">
          <label>
            <i v-if="valid.nameTh" class="el-icon-circle-check valid" />
            <i v-else class="el-icon-warning invalid" /> ชื่อภาษาไทย
          </label>
          <input
            v-model="form.name.tha"
            :placeholder="'ระบุชื่อภาษาไทย'"
            type="text"
            name="nameTh"
            class="input el-input__inner"
          />
        </div>
        <div class="input">
          <label>
            <i v-if="valid.nameEn" class="el-icon-circle-check valid" />
            <i v-else class="el-icon-warning invalid" /> ชื่อภาษาอังกฤษ
          </label>
          <input
            v-model="form.name.eng"
            :placeholder="'ระบุชื่อภาษาอังกฤษ'"
            type="text"
            name="nameEn"
            class="input el-input__inner"
          />
        </div>
      </section>

      <section class="form">
        <div class="input">
          <label>
            <i v-if="valid.address" class="el-icon-circle-check valid" />
            <i v-else class="el-icon-warning invalid" /> รายละเอียดที่อยู่
          </label>
          <NonScAddress
            :selected="form.address"
            :open="ui.address"
            @open="(value) => (ui.address = value)"
            @selected="(value) => (location = value)"
          />
        </div>
      </section>

      <section class="form grid-2">
        <div class="input">
          <label> ถนน </label>
          <input
            v-model="form.address.road"
            :placeholder="'ระบุถนน'"
            type="text"
            name="road"
            class="input el-input__inner"
          />
        </div>
        <div class="input">
          <label> ซอย </label>
          <input
            v-model="form.address.soi"
            :placeholder="'ระบุซอย'"
            type="text"
            name="soi"
            class="input el-input__inner"
          />
        </div>
        <div class="input">
          <label>
            <i v-if="valid.latitude" class="el-icon-circle-check valid" />
            <i v-else class="el-icon-warning invalid" /> ละติจูด
          </label>
          <input
            v-model="form.address.latitude"
            :placeholder="'ระบุละติจูด'"
            type="text"
            name="latitude"
            class="input el-input__inner"
          />
        </div>
        <div class="input">
          <label>
            <i v-if="valid.longitude" class="el-icon-circle-check valid" />
            <i v-else class="el-icon-warning invalid" /> ลองจิจูด
          </label>
          <input
            v-model="form.address.longitude"
            :placeholder="'ระบุลองจิจูด'"
            type="text"
            name="longitude"
            class="input el-input__inner"
          />
        </div>
      </section>

      <section class="footer">
        <el-button
          :disabled="!passed"
          class="action"
          type="sc-asset"
          @click="() => submit()"
        >
          บันทึก
        </el-button>
        <el-button
          v-if="mode == 'update'"
          class="action"
          type="danger"
          @click="() => (confirm.open = true)"
        >
          ลบออก
        </el-button>
        <el-button class="action" type="info" @click="() => cancel()">
          ยกเลิก
        </el-button>
      </section>
    </div>

    <!-- Upload Image -->
    <NonScImageUpload
      :trigger="upload.open"
      :type="upload.type"
      @result="(value) => uploaded(value)"
    />

    <!-- Loader -->
    <div
      v-loading.fullscreen.lock="loader"
      element-loading-background="rgba(0, 0, 0, 0.4)"
    ></div>

    <!-- Alert -->
    <NonScAlert
      :open="alert.open"
      :type="'error'"
      :message="alert.message"
      @closed="() => (alert.open = false)"
    />

    <!-- Confirm -->
    <NonScAlert
      :open="confirm.open"
      :type="'error'"
      :head="confirm.head"
      :message="confirm.message"
      :cancel="true"
      @confirm="() => remove(projectId)"
      @closed="() => (confirm.open = false)"
    />
  </div>
</template>

<script>
// Common
import { NonScCommon as Common } from "../../common/nonsc.common"

// Components
import NonScAddress from "../../components/NonScAddress"
import NonScAlert from "../../components/NonScAlert"
import NonScImageUpload from "../../components/NonScImageUpload"

// Services
// eslint-disable-next-line import/no-cycle
import { NonScFeature } from "../../feature"

// Utils
import { ValidateUtility as Validate } from "../../utils/validate"

export default {
  components: {
    NonScAddress,
    NonScAlert,
    NonScImageUpload,
  },
  data() {
    // Init Alert State
    const alert = {
      open: false,
      message: "null",
    }

    // Init Confirm State
    const confirm = {
      open: false,
      head: "ลบข้อมูล",
      message: null,
    }

    // Init Form State
    const form = {
      type: "NSL",
      code: null,
      name: {
        tha: null,
        eng: null,
      },
      image: {
        cover: null,
        icon: null,
      },
      address: {
        latitude: null,
        longitude: null,
        road: null,
        soi: null,
        tumbonPrefix: null,
        tumbonName: null,
        amphurPrefix: null,
        amphurName: null,
        provinceName: null,
        zipCode: null,
      },
    }

    // Init Image Type
    const { type } = NonScFeature.image

    // Init Upload State
    const upload = {
      open: null,
      type: null,
      image: {
        [type.icon]: null,
        [type.cover]: null,
      },
    }

    // Init UI State
    const ui = {
      address: false,
      [type.icon]: true,
      [type.cover]: true,
    }

    // Init Title State
    const title = {
      create: "สร้างโครงการ",
      update: "แก้ไขโครงการ",
    }

    // Init Location State
    const location = { ...Common.location }

    return {
      mode: null,
      saved: false,
      loader: false,
      alert,
      confirm,
      ui,
      title,
      form,
      upload,
      location,
    }
  },
  computed: {
    clientProject() {
      return NonScFeature.project
    },
    clientImage() {
      return NonScFeature.image
    },
    projectId() {
      return this.$route.params.projectId
    },
    category() {
      return Common.category
    },
    hasIcon() {
      // Icon UI
      const ui = this.ui[this.clientImage.type.icon]

      return ui && this.form.image.icon
    },
    hasCover() {
      // Cover UI
      const ui = this.ui[this.clientImage.type.cover]

      return ui && this.form.image.cover
    },
    valid() {
      // Validator
      const valid = {
        cover: false,
        icon: false,
        code: false,
        nameTh: false,
        nameEn: false,
        address: false,
        latitude: false,
        longitude: false,
      }

      // Name Validator
      const { code, name } = this.form

      // Code Validator
      valid.code = !!code

      // Name Validator
      valid.nameTh = !!name.tha && Validate.isLocale("tha", name.tha)
      valid.nameEn = !!name.eng && Validate.isLocale("eng", name.eng)

      // Image Props
      const { cover, icon } = this.form.image

      // Image URL Validator
      valid.cover = !!cover && Validate.isURL(cover)
      valid.icon = !!icon && Validate.isURL(icon)

      // Address Props
      const { latitude, longitude } = this.form.address

      // Latitude & Longitude Validator
      valid.latitude = !!latitude && Validate.isLatitude(latitude)
      valid.longitude = !!longitude && Validate.isLongitude(longitude)

      // Address Required
      const address = Object.keys(this.form.address)
        .filter(
          (key) =>
            key !== "road" &&
            key !== "soi" &&
            key !== "moo" &&
            key !== "latitude" &&
            key !== "longitude",
        )
        .map((key) => this.form.address[key])

      // Address Validator
      valid.address = address.every((e) => !!e)

      return valid
    },
    passed() {
      return Object.values(this.valid).every((e) => e)
    },
  },
  watch: {
    mode(value) {
      this.$emit("sub-title", this.title[value])
    },
    location: {
      handler(value) {
        // Validate Value
        if (!value) return

        // Set Address
        this.setAddress(value)
      },
      deep: true,
    },
    "upload.image": {
      handler(image) {
        // Validate Upload
        if (!image) return

        // Image Type
        const { type } = this.clientImage

        // Set Icon
        if (image[type.icon]) {
          this.form.image.icon = image[type.icon]
        }

        // Set Cover
        if (image[type.cover]) {
          this.form.image.cover = image[type.cover]
        }
      },
      deep: true,
    },
    "form.code": function formCodeWatcher(value) {
      this.form.code = this.coder(value)
    },
    saved(value) {
      if (value) {
        this.$router.push({
          name: "nonsc-project-list",
        })
      }
    },
    "confirm.open": function confirmOpenWatcher(value) {
      if (value) {
        // Project Props
        const { name } = this.form

        // Set Confirm Message
        this.confirm.message = `ต้องการลบข้อมูลโครงการ${name.tha}?`
      }
    },
  },
  mounted() {
    // Set Unsaved Handler
    window.addEventListener("beforeunload", this.unsaved)

    // Route Props
    const { name } = this.$route

    // Filter Route Name
    switch (name) {
      // Create Handler
      case "nonsc-project-create":
        this.mode = "create"
        break

      // Update Handler
      case "nonsc-project-update":
        this.mode = "update"
        if (!this.projectId) this.fallback()
        this.fetch(this.projectId)
        break

      default:
        this.fallback()
    }
  },
  beforeDestroy() {
    // Unsaved Handler
    this.unsaved()

    // Unset Unsaved Handler
    window.removeEventListener("beforeunload", this.unsaved)
  },
  methods: {
    coder(input) {
      // Validate Input
      if (!(typeof input === "string")) return undefined

      // Code Validator
      return input.replace(/ /gm, "-").toUpperCase()
    },
    imgError(type) {
      this.ui[type] = false
    },
    uploader(type) {
      this.upload.open = new Date().getTime()
      this.upload.type = type
    },
    uploaded(result) {
      // Validate Upload
      if (!result || !result.uri) return

      // Uploaded Props
      const { type, uri } = result

      // Upload Image
      const { image } = this.upload

      // Unsaved Validator
      const isUnsaved = !this.saved && image[type]

      // Unsaved Handler
      if (isUnsaved) {
        this.clientImage.remove(type, image[type])
      }

      // Set Display
      this.ui[type] = true

      // Set Upload Image
      this.upload.image[type] = uri
    },
    setAddress(input) {
      // Set Location
      const location = Common.setLocation(input)

      // Validate Input
      if (location) {
        Object.assign(this.form.address, location)
      }
    },
    async submit() {
      // Filter Mode
      switch (this.mode) {
        // Create Handler
        case "create":
          await this.create(this.form)
          break

        // Update Handler
        case "update":
          await this.update(this.projectId, this.form)
          break

        default:
          break
      }
    },
    async fetch(id) {
      // Loading
      this.loader = true

      try {
        // Validate ID
        if (!id) return

        // Fetch Project
        this.form = await this.clientProject.get(id)
      } catch (_) {
        setTimeout(this.fallback, 400)
      } finally {
        setTimeout(() => {
          this.loader = false
        }, 400)
      }
    },
    async create(form) {
      // Loading
      this.loader = true

      try {
        // Create Project
        const result = await this.clientProject.create(form)

        // Validate Result
        if (result && result.id) {
          this.saved = true
        } else {
          throw new Error("บันทึกข้อมูลผิดพลาด, กรุณาลองใหม่ภายหลัง")
        }
      } catch (error) {
        this.notify(Common.error(error))
      } finally {
        setTimeout(() => {
          this.loader = false
        }, 400)
      }
    },
    async update(id, form) {
      // Loading
      this.loader = true

      try {
        // Update Project
        const result = await this.clientProject.update(id, form)

        // Validate Result
        if (result && result.updated) {
          this.saved = true
        } else {
          throw new Error("บันทึกข้อมูลผิดพลาด, กรุณาลองใหม่ภายหลัง")
        }
      } catch (error) {
        this.notify(Common.error(error))
      } finally {
        setTimeout(() => {
          this.loader = false
        }, 400)
      }
    },
    async remove(id) {
      // Loading
      this.loader = true

      try {
        // Remove Project
        const result = await this.clientProject.remove(id)

        // Validate Result
        if (result && result.deleted) {
          setTimeout(this.fallback, 400)
        } else {
          throw new Error("บันทึกข้อมูลผิดพลาด, กรุณาลองใหม่ภายหลัง")
        }
      } catch (error) {
        this.notify(Common.error(error))
      } finally {
        setTimeout(() => {
          this.loader = false
        }, 400)
      }
    },
    cancel() {
      this.$router.push({
        name: "nonsc-project-list",
      })
    },
    fallback() {
      this.$router.push({
        name: "nonsc-project",
      })
    },
    notify(message) {
      // Validate Message
      if (!message) return

      // Set Notice
      const notice = () => Object.assign(this.alert, { open: true, message })

      // Set Alert
      setTimeout(notice, 400)
    },
    async unsaved() {
      // Validate Saved State
      if (this.saved) return

      // Image Type
      const { type } = this.clientImage

      // Upload Image
      const { image } = this.upload

      // Remove Unused Cover
      if (image[type.cover]) {
        this.clientImage.remove(type.cover, image[type.cover])
      }

      // Remove Unused Icon
      if (image[type.icon]) {
        this.clientImage.remove(type.icon, image[type.icon])
      }
    },
  },
}
</script>

<style lang="css" scoped>
section {
  gap: var(--size-md);
}

.page-content {
  overflow: hidden;
}

.content-wrap {
  display: flex;
  flex-direction: column;
  gap: var(--size-md);
  background-color: white;
  margin-top: var(--size-md);
}

.heading {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: calc(-1 * var(--size-lg));
  margin-bottom: 0;
  height: fit-content;
  height: 300px;
  background-color: var(--color-light);
  border-radius: var(--size-md);
  position: relative;
}

/* Zoom Index */
.heading .cover {
  z-index: 0;
}
.heading .icon,
.heading .upload-cover {
  z-index: 1;
  margin: var(--size-lg);
}
.heading .upload-icon {
  z-index: 3;
}
.icon .backdrop {
  z-index: 2;
}

.backdrop {
  display: flex;
  position: absolute;
  top: 0;
  height: 100%;
  width: 100%;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.15s ease-in-out;
  z-index: 0;
  border-radius: var(--size-md);
}

/* Heading */
.heading .upload-cover,
.heading .upload-icon {
  position: absolute;
  bottom: 0;
  right: 0;
}

/* Icon */
.icon {
  width: 120px;
  background: white;
  border: 0.25rem solid white;
  position: relative;
}
.icon,
.icon .backdrop {
  border-radius: var(--size-sm);
}
.icon .backdrop {
  top: -0.25rem;
  height: calc(100% + 0.5rem);
  width: calc(100% + 0.5rem);
}
.icon img {
  width: 100%;
  aspect-ratio: 1/1;
  object-fit: contain;
  border-radius: var(--size-sm);
}
.icon i {
  font-size: 3rem;
}

.icon .upload-icon {
  bottom: -0.75rem;
  right: -0.75rem;
}

/* Cover */
.cover {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  width: 100%;
  height: 100%;
}
.cover img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  border-radius: var(--size-md);
}
.cover i {
  font-size: 4rem;
}

.cover:hover .backdrop,
.icon:hover .backdrop {
  cursor: pointer;
  opacity: 1;
  z-index: 3;
}

.icon:hover .backdrop {
  background-color: rgba(255, 255, 255, 0.95);
}
.cover:hover .backdrop {
  background-color: rgba(255, 228, 207, 0.95);
}

/* Footer */
.footer {
  display        : flex;
  justify-content: center;
  gap            : var(--size-md);
}
.footer .action {
  min-width: 6rem;
}

/* Input Radio */
.el-radio-group {
  display: flex;
}
.el-radio-group >>> label {
  flex: 1;
}
.el-radio-group >>> .el-radio-button__inner {
  width: 100%;
}

.code {
  padding: 0.125rem;
  font-family: monospace;
}

@media screen and (max-width: 1024px) {
  .heading {
    margin: calc(-1 * var(--size-md));
    margin-bottom: 0;
  }

  .icon {
    width: 100px;
  }

  .heading {
    height: 240px;
  }
}

@media screen and (max-width: 480px) {
  section.form.grid-2 {
    grid-template-columns: 1fr;
  }
}

@media screen and (max-width: 320px) {
  .icon {
    width: 80px;
  }

  .heading {
    height: 200px;
  }
}
</style>
